import type { FormBlockContext } from '#layers/forms/types/form-block';
import { createContext } from 'reka-ui';

export const [injectFormBlockContext, provideFormBlockContext] = createContext<FormBlockContext>('FormBlock');
